import { useCallback } from 'react'
import { harvestFarm } from 'utils/calls'
import { useCraftsmanV2 } from 'hooks/useContract'
import { refreshFarmUserDataFromPid } from 'state/farms/useDeserializedFarmsUser'
import { DEFAULT_GAS_LIMIT_CRAFTSMAN_V2 } from 'config'

const useHarvestFarmV2 = (farmPid: number) => {
  const craftsmanV2Contract = useCraftsmanV2()

  const handleHarvest = useCallback(
    () =>
      harvestFarm(craftsmanV2Contract, farmPid, DEFAULT_GAS_LIMIT_CRAFTSMAN_V2).finally(() => {
        refreshFarmUserDataFromPid(farmPid, 2)
      }),
    [farmPid, craftsmanV2Contract],
  )

  return { onReward: handleHarvest }
}

export default useHarvestFarmV2
